import{unstable_getScrollbarSize as _0xff4d4e}from'@mui/utils';export default _0xff4d4e;